import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledMyIssueDeviceDetail = styled(Box)(({ theme }) => `
  display: flex;
  flex-direction: column;
  @media (min-width: ${theme.breakpoints.sm}) {
    flex-direction: row;
  }
  
  .thumbnail {
    flex: 1;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      max-height: 180px;
      object-fit: contain;
    }
  }

  .device-info {
    flex: 1;
    margin-left: ${theme.uptimeSpace[12]}px;

    & > div {
      margin-bottom: ${theme.uptimeSpace[10]}px;
      .manufacturer {
        margin: 0;
        text-transform: uppercase;
        color: ${theme.uptimeColors.grayScales.darkerGray};
        font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        line-height: 1.15;
      }
      .model {
        margin: 0;
        color: ${theme.uptimeColors.textColors.primary};
        font-size: ${theme.uptimeFontSizes.desktop.fz8}px;
        font-weight: 600;
        line-height: initial;
        word-break: break-word;
        text-transform: capitalize;
      }
    }

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        padding: ${theme.uptimeSpace[2]}px 0;
        font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        line-height: 1.2 !important;
        display: flex;
        align-items: center;
        svg {
          color: ${theme.uptimeColors.textColors.primary};
          font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        }
        .label {
          margin-left: ${theme.uptimeSpace[3]}px;
          margin-right: ${theme.uptimeSpace[2]}px;
          font-weight: 700;
          color: ${theme.uptimeColors.textColors.primary};
          white-space: nowrap;
          text-transform: capitalize;
        }
        .value {
          word-break: break-word;
        }
        .btn-copy {
          border: 0;
          background-color: transparent;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
`);
  